import React from "react";

import t, { AsHtml } from "../../../utils/translate";
import { ChoiceButton } from "@ww-digital/web-foundations-react/modules";

import styles from "./styles.module.scss";

const GdprConsent = ({ onChange, value }) => (
  <ChoiceButton
    type="checkbox"
    name="gdprConsent"
    value="gdprConsent"
    title={<AsHtml value={t("GDPR_LABEL")} />}
    checked={value}
    onChange={e => onChange(e.target.checked)}
    className={styles.gdprWrapper}
  />
);

export default GdprConsent;
